import Link, { LinkProps as NextLinkProps } from 'next/link';

import { LinkProps } from '@/ui/Link';

export type AppLinkProps = Omit<LinkProps, keyof NextLinkProps> & NextLinkProps;

export function AppLink(
    props: Omit<AppLinkProps, 'passHref' | 'legacyBehavior'>
) {
    return <Link {...props} passHref legacyBehavior />;
}
